import {
  DropdownMenuItem,
  DropdownMenuSeparator,
} from "@components/ui/dropdown-menu";
import { CheckCircle2Icon, MailIcon, UserPlus2Icon } from "lucide-react";
import { Link } from "react-router-dom";
import { ROUTES } from "@/routes_new";
import { Trans } from "@lingui/react/macro";

export function UserActions({ orgUuid }: { orgUuid: string }) {
  return (
    <>
      <DropdownMenuItem asChild>
        <Link to={ROUTES.SETTINGS_ACCOUNT_ORGID.replace(":orgUuid", orgUuid)}>
          <CheckCircle2Icon />
          <Trans>Abonnemangsinformation</Trans>
        </Link>
      </DropdownMenuItem>

      <DropdownMenuSeparator />

      <DropdownMenuItem asChild>
        <Link to={ROUTES.INVITE_USER_ORGID.replace(":orgUuid", orgUuid)}>
          <UserPlus2Icon />
          <Trans>Bjud in kollegor</Trans>
        </Link>
      </DropdownMenuItem>

      <DropdownMenuItem asChild>
        <Link
          to={
            ROUTES.SETTINGS_MY_ACCOUNT_ORGID.replace(":orgUuid", orgUuid) +
            "?subscriptions=true"
          }
        >
          <MailIcon />
          <Trans>Notisinställningar</Trans>
        </Link>
      </DropdownMenuItem>
    </>
  );
}
